import React from 'react';
import { GenericFormPage } from '../../../components/generic';
import { usePmsIntervalUnit, PmsIntervalUnit } from './useData';
import { moduleConfig, getInitialFormData, mapItemToFormData } from './config';

const Form: React.FC = () => (
  <GenericFormPage<PmsIntervalUnit>
    useData={usePmsIntervalUnit}
    config={{
      ...moduleConfig,
      getInitialFormData,
      mapItemToFormData,
    }}
  />
);

export default Form;
